(function ($, Drupal, lottie) {
  Drupal.behaviors.lottieInit = {
    attach: function (context, settings) {

      once('lottieInit', '.js-lottie').forEach(function (el) {
        lottie.loadAnimation({
          container: el, // the dom element that will contain the animation
          renderer: 'svg',
          loop: true,
          autoplay: true,
          path: el.dataset.lottiefile // the path to the animation json
        });

      });

    }
  }
})(jQuery, Drupal, lottie);
